import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { IThunkClinicArchive, IClinicStore, IClinicActions } from '../types';

const onArchiveClinic: IThunkClinicArchive = thunk(
  async ({ setClinics }: Actions<IClinicActions>, clinicId, { getState }) => {
    const localState = getState() as IClinicStore;

    await api.clinic.archiveClinic(clinicId);

    const updatedList = localState.list.map(clinic =>
      clinic.id !== clinicId ? clinic : { ...clinic, isArchived: true },
    );

    setClinics({ items: updatedList });
  },
);

export default onArchiveClinic;
